import { render } from "./List.vue?vue&type=template&id=6f885852"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

import "./List.vue?vue&type=style&index=0&id=6f885852&lang=scss"
script.render = render

export default script